"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EduHomeInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var lifeHome_1 = require("../../model/lifeHome");
var service_1 = require("../../../library/base/service");
var EduHomeInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(EduHomeInit, _super);
    function EduHomeInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '教育首页';
        _this.code = '101091';
        _this.desc = '教育首页';
        _this.requestParams = new lifeHome_1.EduHomeInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return EduHomeInit;
}(service_1.BaseService));
exports.EduHomeInit = EduHomeInit;
//# sourceMappingURL=eduHomeInit.js.map